import { render, staticRenderFns } from "./bi-form-view-item.vue?vue&type=template&id=14b09d98&scoped=true&"
import script from "./bi-form-view-item.vue?vue&type=script&lang=ts&"
export * from "./bi-form-view-item.vue?vue&type=script&lang=ts&"
import style0 from "./bi-form-view-item.vue?vue&type=style&index=0&id=14b09d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b09d98",
  null
  
)

export default component.exports